import { createFileRoute } from '@tanstack/react-router';
import { useDashboardContext } from './dashboard-context';
import { RisksDashboard } from './sections/Risks';

export const Route = createFileRoute('/console/$orgId/dashboard/risks')({
    component: RouteComponent,
});

function RouteComponent() {
    const { dashboards } = useDashboardContext();

    return <RisksDashboard loading={dashboards.loading.risksDashboard} data={dashboards.data.risksDashboard} />;
}
